import { ProjectFollowUpQuestions } from './ProjectFollowUpQuestions';

interface ProjectReplyFollowUpQuestionsProps {
  projectId: string;
  replyId: string;
  onSelect: (question: string) => void;
}

export const ProjectReplyFollowUpQuestions = ({
  projectId,
  replyId,
  onSelect,
}: ProjectReplyFollowUpQuestionsProps) => (
  <div className="duration-300 animate-in fade-in">
    <ProjectFollowUpQuestions
      key={replyId}
      projectId={projectId}
      replyId={replyId}
      enabled
      onSelect={onSelect}
    />
  </div>
);
